var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"overlay","appear":""}},[(_vm.open)?_c('div',{staticClass:"overlay",on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }